import { FieldValues, UseFormReset } from 'react-hook-form';

import storageService from '../services/storage.service';

const getDefaultValuesIndexedDB = async (
  key: string,
  reset?: UseFormReset<FieldValues>,
  properties?: string[],
  defaultValues?: Record<string, unknown>,
) => {
  const formData: FieldValues | null = await storageService.getItem(key);

  if (!formData) return;

  if (!properties) {
    if (reset) reset({ ...formData });
    return formData;
  } else {
    const newFormData: Record<string, unknown> = properties.reduce((acc, cv: string) => {
      if (formData[cv] !== null && formData[cv] !== undefined) {
        return (acc = {
          ...acc,
          [cv]: formData[cv] as FieldValues,
        });
      }

      return acc;
    }, {});
    if (Object.keys(newFormData).length === 0 && newFormData.constructor === Object) return;
    if (reset) reset({ ...defaultValues, ...newFormData });
    return newFormData;
  }
};

const addDataToIndexedDb = async (data: Record<string, unknown>, key: string) => {
  const cacheData: Record<string, unknown> | null = await storageService.getItem(key);
  await storageService.setItem(key, { ...cacheData, ...data });
};

export { getDefaultValuesIndexedDB, addDataToIndexedDb };
